import { AxiosResponse } from 'axios';
import { api as companiesApi } from 'services/companiesApi';
import { Candidate } from 'types';

export const postRejectCandidate = async (
	candidates: Candidate[],
): Promise<AxiosResponse> => {
	const payload = {
		candidates: candidates.map((candidate) => ({
			id: candidate.id,
		})),
	};

	return await companiesApi.post(`/candidates/reject`, payload);
};
